/**
 * The page a firm-staff member sees on a console URL their role cannot use.
 *
 * Round 11, round 10. The /admin gate used to mount any /admin page for any
 * firm-staff role and leave it to the page's own reads to fail: a relationship
 * manager who typed /admin/billing met a screen of 403 cards and console
 * errors. `lib/authz/admin-route-access.ts` now decides, from the same server
 * tiers the page's reads are checked against, and this is what the gate
 * renders instead of the page. Nothing on it reads data, so nothing can fail.
 */

import { useNavigate } from '@tanstack/react-router';
import { AdminLayout } from '../layouts/admin-layout';
import { StateCard } from '../state-card';

export function NotAvailableToRole({ page }: { page: string }) {
  const navigate = useNavigate();
  return (
    <AdminLayout eyebrow={page} title="Not available to your role" sub="Firm console">
      <StateCard
        variant="empty"
        testId="not-available-to-role"
        label="Not available"
        headline={`${page} is not open to your role in this firm.`}
        detail="Your firm administrator decides who can use each part of the console. Everything on your menu is open to you."
        action={{
          label: 'Go to your clients',
          onClick: () => void navigate({ to: '/admin/client-book' }),
        }}
      />
    </AdminLayout>
  );
}
